import React from 'react';

import { getColWidthCalc } from '@zego/theme';
import { getCountrySupportLink } from '@zego/utils/route';

import RegularText from '@zego/components/atoms/RegularText';
import View from '@zego/components/atoms/View';
import BlockListSection from '@zego/components/BlockListSection';
import Link from '@zego/components/Link';

function MapRows(rowsData) {
  return rowsData.map(listItem => ({
    icon: listItem.icon,
    heading: listItem.heading,
    link: listItem.link,
    itemsPerRow: 3,
    textAlign: 'left',
  }));
}

const footerText = (
  <View css={{ display: 'flex', justifyContent: 'center' }}>
    <RegularText
      css={{
        textAlign: 'center',
        width: getColWidthCalc(12, 20, 8),
      }}
    >
      For more information visit our{' '}
      <Link href={getCountrySupportLink()}>support</Link> page
    </RegularText>
  </View>
);

export default function Faqs({ title, rowsData }) {
  const rows = MapRows(rowsData);
  return (
    <BlockListSection title={title} listData={rows} footerText={footerText} />
  );
}
